import React from "react";

type AuthContextType = {};
export const AuthContext = React.createContext<AuthContextType>({} as AuthContextType);
